import React from 'react';
import { FaTiktok, FaYoutube, FaInstagram } from 'react-icons/fa';
import { FiCheck } from 'react-icons/fi';
import './landing-v2.css';

// Left column of the v2 tool hero — gives the user context/title beside the
// upload form so the top of the page isn't a lone, empty upload box.
const LandingToolInfo = () => {
    return (
        <div className="lp2-tool-info">
            <span className="lp2-ti-eyebrow">AI Shorts Generator</span>
            <h1>Turn long videos into <span className="lp2-ti-grad">viral shorts</span></h1>
            <p className="lp2-ti-sub">
                Upload a talking video and our AI finds the best moments, adds captions, keeps faces
                centered, and gets each clip ready to post to TikTok, YouTube, and Instagram.
            </p>
            <ul className="lp2-tool-list">
                <li><FiCheck /> No editing skills needed</li>
                <li><FiCheck /> Auto captions, face tracking &amp; virality scoring</li>
                <li><FiCheck /> Publish straight to TikTok</li>
            </ul>
            <div className="lp2-tool-trust">
                <div className="lp2-tool-platforms">
                    <FaTiktok title="TikTok" />
                    <FaYoutube title="YouTube" />
                    <FaInstagram title="Instagram" />
                </div>
                <div className="lp2-tool-proof">
                    <span className="lp2-stars">★★★★★</span> Loved by 40,000+ creators
                </div>
            </div>
        </div>
    );
};

export default LandingToolInfo;
